import { Fragment, PureComponent, ReactNode } from 'react';
import { Element } from './types';
import { Slider } from 'antd';

interface Props {
    element: Element;
    onChange: (ref: string, value: number) => void;
}

const MarkDiv: React.FC<{ value: number; text: string }> = ({ value, text }) => {
    return (
        <div>
            <div style={{ color: 'rgba(0, 0, 0, .45)' }}>{value}</div>
            <div style={{ color: '#000' }}>{text}</div>
        </div>
    );
};

class SliderInput extends PureComponent<Props> {
    render(): ReactNode {
        const { element, onChange } = this.props;
        const { label, settings, ref } = element;
        const { min = 0, max = 0 } = settings;
        const marks = {
            [min]: <MarkDiv value={0} text="Low" />,
            [max]: <MarkDiv value={5} text="High" />,
            ...Array.from(
                {
                    length: max - min - 1,
                },
                (_, index) => min + index + 1,
            ).reduce(
                (acc, value) => ({
                    ...acc,
                    [value]: value.toString(),
                }),
                {},
            ),
        };

        return (
            <div className="pb-20">
                <p className="text-16 font-700">{label}</p>
                <Slider
                    min={settings.min}
                    max={settings.max}
                    step={settings.step}
                    value={settings.defaultValue}
                    onChange={(value) => onChange(ref, value)}
                    marks={marks}
                />
            </div>
        );
    }
}

export default SliderInput;
